import { ReactComponent as ArrowRightFilledSvg } from '@frontend/icons/arrow-right-filled.svg';
import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import { links } from '../../constants';
import { useWidgetContext } from '../../context/WidgetContext';
import { useRegisterHotjarPage } from '../../hooks';

import { PageFields_CancelledPage_Fragment as CancelledPageFields } from '../../graphql/generated';

interface UnsupportedCountryProps {
  data: CancelledPageFields['cancelledPageData'];
}

export default function UnsupportedCountry({
  data,
}: UnsupportedCountryProps): JSX.Element {
  useRegisterHotjarPage('unsupported-country');

  const { configureHeader } = useWidgetContext();

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: data?.merchantName || '',
      billType: data?.billType,
    });
  }, [configureHeader, data?.merchantName, data?.billType]);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent title="Unsupported country" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="😕"
              title="Unsupported country"
              description={
                <>
                  Unfortunately our services are currently
                  <br /> not available in your location
                </>
              }
            />
          }
          footer={
            <Button
              as="a"
              size="large"
              variant="ghost"
              target="_blank"
              rel="noopener noreferrer"
              href={links.support.MERCHANT_ELIGIBILITY_AND_RESTRICTED_COUNTRIES}
              rightIcon={<Icon component={<ArrowRightFilledSvg />} />}
            >
              Learn more
            </Button>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
}
